/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/MsftSlideOutIconButton',['pixi', 'absolute', 'lodash', 'MenuUI/MsftButton', 'absolute/stringmanager'],

    function (PIXI, Absolute, _, MsftButton, StringManager) {

        var MsftSlideOutIconButton = function (options) {
            this._initMsftSlideOutIconButton(options);
        };

        MsftSlideOutIconButton.constructor = MsftSlideOutIconButton;
        MsftSlideOutIconButton.prototype = Object.create(MsftButton.prototype);

        MsftSlideOutIconButton.prototype._initMsftSlideOutIconButton = function (options) {

            this.fontSize = Absolute.ScreenMetrics.getResScale() * 23;

            var defaultOptions = {
                letterStyle: {
                    font: this.fontSize + "px Arial",
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    align: 'left'
                },
                upStroke: true,
                hoverColor: 0x56739b
            };

            if (options.textColor) {
                defaultOptions.letterStyle.fill = options.textColor;
            }

            MsftButton.call(this, _.extend(defaultOptions, options));
        };

        MsftSlideOutIconButton.prototype.handleAction = function () {
            Absolute.AudioManager.playSound('button');
            this.options.action(this.options.data, this);
        };

        MsftSlideOutIconButton.prototype._createTexture = function (threeSliceOptions, type) {
            var container = new PIXI.DisplayObjectContainer(),
                icon = PIXI.Sprite.fromFrame(this.options.icon),
                text = new PIXI.Text(this.options.text, this.options.letterStyle),
                background = new PIXI.Graphics(),
                xOffset = Absolute.Coords.x(50);

            StringManager.shrinkToFit(text, this.fontSize, '', Absolute.ScreenMetrics.getResScale() * 215);
            text.anchor.set(0.5, 0.5);
            background.beginFill(this.options.hoverColor, type == 'over' || type == 'down' ? 1 : 0);
            background.drawRect(0, 0, Absolute.Coords.x(360), Absolute.Coords.x(53));
            background.endFill();
            container.addChild(background);

            icon.x = xOffset;
            icon.y = Absolute.Coords.y(10);

            text.x = xOffset + text.width / 2 + Absolute.Coords.x(45);
            text.y = Absolute.Coords.y(32);

            container.addChild(icon);
            container.addChild(text);

            return container.generateTexture();
        };



        return MsftSlideOutIconButton;

    });
